declare global {
  interface Window {
    DocumentTouch: any
  }
}

const checkTouchEvents = (): boolean => {
  if (typeof window !== 'undefined') {
    return (
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch) ||
      navigator.maxTouchPoints > 0 ||
      //@ts-expect-error navigator.msMaxTouchPoints - неизвестное свойство
      window.navigator.msMaxTouchPoints > 0
    )
  }
  return false
}

export { checkTouchEvents }
